import defaultShows from '../assets/defaults/defaultShows';

export default {
  namespaced: true,

  state: () => ({
    //Set to true to enable debugging
    debug: false,
    activeTab: 'podcasts',
    howler: null,
    status: {
      playing: false,
      muted: false,
    },
    episode: null,
    timestamp: 0,
    current: defaultShows[0],
    streaming: false,
    stream: null,
    show: null,
    streamUrl: null,
    apiUrl: null
  }),

  mutations: {
    setActiveTab(state, tab) { state.activeTab = tab; },
    setStreamUrl(state, url) { state.streamUrl = url; },
    setApiUrl(state, url) { state.apiUrl = url; },
    setCurrentEpisode(state, episode) { state.episode = episode; },
    setCurrentTrack(state, track) { state.current = track; },
    setCurrentShow(state, show) { state.show = show; },
    setPlayerStatus(state, status) { state.status = status; },
    setPlayerMuted(state, status) { state.status.muted = status; },
    setTimestamp(state, status) { state.timestamp = status; },
    setStreamInfo(state, stream) { state.stream = stream; },
  },

  getters: {
    getCurrentTrack(state) {
      return state.current;
    },
  },

  actions: {
    setStreamUrl({ commit }, url) {
      commit('setStreamUrl', url);
    },

    startStream({ dispatch, commit }, track) {
      commit('setCurrentTrack', { url: track });
      dispatch('startPlayer');
    },

    setShow({ state, commit, dispatch }, show) {
      if (state.show) if (state.show.id == show.id) dispatch('setEpisode', state.episode.nr);

      commit('setCurrentShow', show);
      dispatch('setEpisode', show.fields.broadcast_files.length - 1);
    },

    previousEpisode({ dispatch, state }) {
      if (state.episode.nr <= 0) return;

      dispatch('setEpisode', state.episode.nr - 1);
    },

    nextEpisode({ dispatch, state }) {
      if ((state.show.fields.broadcast_files.length - 1) <= state.episode.nr) return;

      dispatch('setEpisode', state.episode.nr + 1);
    },

    setEpisode({ commit, state }, episodeNr) {

      if (!state.show.fields.broadcast_files[episodeNr]) { return; }

      let episode = {
        episode: 'Episode',
        nr: episodeNr,
        name: 'Name',
        presenter: '',
      }

      if (state.show.fields.broadcast_files[episodeNr]) {
        episode.episode = state.show.fields.broadcast_files[episodeNr].broadcast_title ?? 'Episode';
      }

      if (state.show.programs[0]) {
        episode.name = state.show.programs[0].name ?? 'Name';
      }

      if (state.show.speakers[0]) {
        episode.presenter = state.show.speakers[0].name ?? 'Presenter';
      }

      commit('setCurrentEpisode', episode);
      commit('setCurrentTrack', { url: state.show.fields.broadcast_files[episodeNr].broadcast_file.url });
    },

    // Set status so the mutations on the status object are detected by
    // watching functionality
    toggleStartPlayer({ commit, state }) {
      var status = { ...state.status };
      status.playing = !status.playing;
      commit('setPlayerStatus', status);
    },
    startPlayer({ commit, state }) {
      var status = { ...state.status };
      status.playing = true;
      commit('setPlayerStatus', status);
    },
    stopPlayer({ commit, state }) {
      var status = { ...state.status };
      status.playing = false;
      commit('setPlayerStatus', status);
    },
    toggleMutePlayer({ commit, state }) {
      var status = { ...state.status };
      status.muted = !status.muted;
      commit('setPlayerStatus', status)
    },
    mutePlayer({ commit, state }) {
      var status = { ...state.status };
      status.muted = true;
      commit('setPlayerStatus', status)
    },
    unmutePlayer({ commit, state }) {
      var status = { ...state.status };
      status.muted = false;
      commit('setPlayerStatus', status)
    }
  },
};